import { BaseEventTracking } from '/@/modules/core/app/models/abstracts/BaseEventTracking';
import { SegmentEvent } from '/@/integrations/segment/SegmentEvent';

export class DiagnosticCompletedEventTracking extends BaseEventTracking {
  static eventName: SegmentEvent = SegmentEvent.DIAGNOSTIC_COMPLETED;

  formId: string;

  constructor(formId: string) {
    super();
    this.formId = formId;
  }
}
